import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import TextField from '@/components/atoms/TextField';

import styles from './CheckboxMenu.module.scss';

interface CheckboxMenuSearchProps {
    /** The menu's own label, named in the field's accessible name. */
    label: string;
    query: string;
    searchRef: RefObject<HTMLInputElement | null>;
    onQueryChange: (query: string) => void;
}

export default function CheckboxMenuSearch({
    label,
    query,
    searchRef,
    onQueryChange,
}: CheckboxMenuSearchProps) {
    const { t } = useTranslation();
    return (
        <TextField
            ref={searchRef}
            type="search"
            className={styles.search}
            value={query}
            placeholder={t('molecules.checkboxMenu.searchPlaceholder')}
            aria-label={t('molecules.checkboxMenu.searchLabel', { label })}
            onChange={(event) => onQueryChange(event.target.value)}
        />
    );
}
